<div class="lum-modal shipping-label-with-packing-slip__wrapper">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large"
      >Export Labels With Packing Slip</span
    >
  </div>
  <div class="lum-modal__body">
    <div class="form-group">
      <label>Packing Slip Page Size</label>
      <mat-select
        class="lum-select"
        placeholder="Select page size"
        [(value)]="packingSlipPageSize"
      >
        <mat-option [value]="ePageSize.A4">A4 (8.5x11)</mat-option>
        <mat-option [value]="ePageSize.A6">A6 (4x6)</mat-option>
      </mat-select>
    </div>
  </div>
  <div class="lum-modal__footer">
    <button
      [disabled]="(loading$ | async) || false"
      mat-button
      type="button"
      class="lum-button lum-button--secondary ml-auto mr-2"
      (click)="onClose()"
    >
      Cancel
    </button>
    <ng-container>
      <button
        [disabled]="(loading$ | async) || false"
        mat-button
        type="button"
        class="lum-button lum-button--secondary"
        (click)="onSubmit()"
      >
        Export
      </button>
    </ng-container>
  </div>
</div>

<ng-template #loader>
  <div class="w-100">
    <mat-spinner diameter="20" class="mx-auto"></mat-spinner>
  </div>
</ng-template>

<ng-template #noRecords>
  <div class="text-center p-4">
    <h3>No records available.</h3>
  </div>
</ng-template>
